import * as React from "react";
import { UitkIcon } from "../uitk-react-icons/index.js";
import { classNames } from "../uitk-react-utils/index.js";
import { UitkFieldMessage } from "./index.js";
export class UitkField extends React.Component {
  static displayName = "UitkField";
  static defaultProps = {
    hasBorder: true,
    hasFloatedLabel: true,
    hasVisibleLabel: true
  };
  render() {
    const {
      className,
      label,
      instruction,
      invalid,
      hasFloatedLabel,
      icon,
      hasAutofill,
      hasBorder,
      hasVisibleLabel,
      children,
      required,
      style,
      id,
      disabled,
      placeholder,
      readOnly
    } = this.props;
    const cssClassNames = classNames("uitk-field", className, {
      "has-autofill": hasAutofill,
      "has-floatedLabel-label": hasFloatedLabel,
      "has-icon": icon,
      "has-no-border": !hasBorder,
      "has-no-placeholder": !placeholder?.trim(),
      "has-no-visible-label": !hasVisibleLabel,
      "has-placeholder": !!placeholder?.trim(),
      "has-textarea": React.Children.toArray(children).some((child) => !!(child?.type === "textarea")),
      "is-disabled": disabled,
      "is-invalid": invalid,
      "is-readonly": readOnly,
      "is-required": required
    });
    const labelClassNames = [];
    if (!hasVisibleLabel) {
      labelClassNames.push("is-visually-hidden");
    }
    const messageMarkup = (message, type) => {
      let output;
      const isString = (val) => typeof val === "string";
      const isObject = (val) => typeof val === "object";
      if (message) {
        if (isString(message)) {
          output = /* @__PURE__ */ React.createElement(UitkFieldMessage, { id, message, type });
        }
        if (isObject(message)) {
          output = /* @__PURE__ */ React.createElement("div", { className: classNames("uitk-field-messages") }, message.primary && /* @__PURE__ */ React.createElement(
            UitkFieldMessage,
            {
              className: classNames("uitk-field-message-primary"),
              id,
              message: message.primary,
              type
            }
          ), message.secondary && /* @__PURE__ */ React.createElement(
            UitkFieldMessage,
            {
              className: classNames("uitk-field-message-secondary"),
              id,
              message: message.secondary,
              type
            }
          ));
        }
      }
      return output;
    };
    return /* @__PURE__ */ React.createElement(React.Fragment, null, hasVisibleLabel ? /* @__PURE__ */ React.createElement("label", { className: cssClassNames, style, htmlFor: id }, children, /* @__PURE__ */ React.createElement("span", { className: classNames("uitk-field-label", labelClassNames) }, label), icon && /* @__PURE__ */ React.createElement(UitkIcon, { className: classNames("uitk-field-icon"), name: icon })) : /* @__PURE__ */ React.createElement("div", { className: cssClassNames, style }, children, /* @__PURE__ */ React.createElement("span", { className: classNames("uitk-field-label", labelClassNames) }, label), icon && /* @__PURE__ */ React.createElement(UitkIcon, { className: classNames("uitk-field-icon"), name: icon })), invalid && messageMarkup(invalid, "error"), instruction && messageMarkup(instruction, "instruction"));
  }
}
